import {
  BsLaptop,
  BsHeartPulse,
  BsBriefcase,
  BsBook,
  BsGear,
  BsNewspaper,
  BsCashCoin,
  BsGlobe2,
} from "react-icons/bs";

const majors = [
  {
    name: "الطب والعلوم الصحية",
    icon: BsHeartPulse,
    subMajors: [
      "الطب",
      "طب الأسنان",
      "التمريض",
      "الصيدلة",
      "العلوم الطبية التطبيقية",
      "الخدمات الطبية الطارئة",
      "المختبرات الطبية",
      "الأشعة",
      "العلاج الطبيعي",
      "الصحة العامة",
      "إدارة الخدمات الصحية",
    ],
  },
  {
    name: "الهندسة والطاقة",
    icon: BsGear,
    subMajors: [
      "الهندسة المدنية",
      "الهندسة الكهربائية",
      "الهندسة الميكانيكية",
      "الهندسة الصناعية",
      "الهندسة الكيميائية",
      "الهندسة المعمارية",
      "هندسة بيئية",
      "العمارة",
      "التخطيط العمراني",
      "هندسة الحاسب",
      "هندسة الطاقة",
      "الطاقة المتجددة",
      "السلامة والصحة المهنية",
    ],
  },
  {
    name: "الحاسب والتقنية",
    icon: BsLaptop,
    subMajors: [
      "علوم الحاسب",
      "نظم المعلومات الإدارية",
      "نظم المعلومات",
      "تقنية المعلومات",
      "الدعم الفني",
      "الدعم الفني للحاسب",
      "تقنية الدعم الفني",
      "تقنية اتصالات",
      "هندسة البرمجيات",
      "هندسة الحاسب",
      "الأمن السيبراني",
      "الذكاء الاصطناعي",
      "علم البيانات",
      "البرمجة التطبيقية",
      "الشبكات",
    ],
  },
  {
    name: "القانون والسياسة",
    icon: BsBriefcase,
    subMajors: [
      "قانون ومحاماة",
      "الأنظمة",
      "الحقوق",
      "الشريعة",
      "الدراسات الإسلامية",
      "العلوم السياسية",
    ],
  },
  {
    name: "المالية والإدارية",
    icon: BsCashCoin,
    subMajors: [
      "الإدارة",
      "إدارة الأعمال",
      "الإدارة العامة",
      "الإدارة الصحية",
      "الموارد البشرية",
      "التسويق",
      "المالية",
      "المحاسبة",
      "الاقتصاد",
      "التأمين",
      "إدارة المخاطر",
      "التأمين وإدارة المخاطر",
      "البنوك والاستثمار",
      "المراجعة والحوكمة",
      "التحليل الكمي",
      "إدارة المشاريع",
      "سلاسل الإمداد واللوجستيات",
      "ريادة الأعمال",
    ],
  },
  {
    name: "السياحة والضيافة",
    icon: BsGlobe2,
    subMajors: [
      "السياحة والضيافة",
      "إدارة الضيافة",
      "إدارة الفعاليات",
      "الآثار",
      "التراث",
      "الإرشاد السياحي",
    ],
  },
  {
    name: "الإعلام والإتصال",
    icon: BsNewspaper,
    subMajors: [
      "الصحافة والإعلام",
      "الصحافة والنشر الإلكتروني",
      "الإذاعة والتلفزيون والفيلم",
      "العلاقات العامة",
      "الاتصال المؤسسي",
      "الاتصال التسويقي والإعلان",
      "الإعلام الرقمي",
    ],
  },
  {
    name: "اللغات والآداب",
    icon: BsBook,
    subMajors: [
      "اللغة العربية",
      "اللغة العربية وآدابها",
      "اللغة الإنجليزية",
      "اللغة الإنجليزية وآدابها",
      "الترجمة",
    ],
  },
  {
    name: "التصميم والفنون",
    icon: BsNewspaper,
    subMajors: [
      "التصميم",
      "تصميم الجرافيك",
      "تصميم تجربة المستخدم",
      "تصميم واجهات المستخدم",
      "الإنتاج المرئي",
      "الفنون",
      "الفنون الرقمية",
    ],
  },
  {
    name: "العلوم الأساسية",
    icon: BsBook,
    subMajors: [
      "العلوم",
      "الرياضيات",
      "الإحصاء",
      "الفيزياء",
      "الكيمياء",
      "الأحياء",
      "علوم الأرض",
      "العلوم البيئية",
    ],
  },
  {
    name: "العلوم الإنسانية",
    icon: BsBook,
    subMajors: [
      "التاريخ والحضارة",
      "الجغرافيا",
      "نظم المعلومات الجغرافية",
      "علم المعلومات",
      "المكتبات والمعلومات",
    ],
  },
  {
    name: "العلوم الإجتماعية",
    icon: BsBook,
    subMajors: [
      "الخدمة الاجتماعية",
      "علم النفس",
      "علم الاجتماع",
      "العلوم السياسية",
    ],
  },
  {
    name: "العلوم التربوية",
    icon: BsBook,
    subMajors: [
      "التربية الخاصة",
      "الطفولة المبكرة",
      "علم النفس التربوي",
      "تقنيات التعليم",
      "المناهج وطرق التدريس",
      "الإدارة التربوية",
    ],
  },
  {
    name: "العلوم الزراعية",
    icon: BsGlobe2,
    subMajors: [
      "العلوم الزراعية",
      "علوم الأغذية",
      "التغذية",
      "الإنتاج النباتي",
      "الإنتاج الحيواني",
      "علوم التربة والمياه",
      "الاقتصاد الزراعي",
      "وقاية النبات",
      "البيئة والاستدامة",
    ],
  },
  {
    name: "العلوم الرياضية",
    icon: BsBook,
    subMajors: [
      "علوم الرياضة والنشاط البدني",
      "التدريب الرياضي",
      "الإدارة الرياضية",
      "الأمن والسلامة",
    ],
  },
  {
    name: "تخصصات الدبلوم",
    icon: BsBriefcase,
    subMajors: [
      "دبلوم دعم فني",
      "دبلوم تقنية معلومات",
      "دبلوم شبكات الحاسب",
      "دبلوم برمجة الحاسب",
      "دبلوم أمن سيبراني",
      "دبلوم إدارة أنظمة الشبكات",
      "دبلوم إدارة مكتبية",
      "دبلوم إدارة أعمال",
      "دبلوم موارد بشرية",
      "دبلوم محاسبة",
      "دبلوم تسويق",
      "دبلوم مالية وبنوك",
      "دبلوم تأمين",
      "دبلوم إدارة مخاطر",
      "دبلوم سلاسل الإمداد",
      "دبلوم لوجستيات",
      "دبلوم سلامة وصحة مهنية",
      "دبلوم علاقات عامة",
      "دبلوم إعلام رقمي",
      "دبلوم تصميم جرافيك",
      "دبلوم تصميم واجهات",
      "دبلوم سياحة وضيافة",
      "دبلوم إدارة فعاليات",
      "دبلوم فندقة",
      "دبلوم سفر وسياحة",
      "دبلوم كهرباء",
      "دبلوم ميكانيكا",
      "دبلوم إلكترونيات",
      "دبلوم تبريد وتكييف",
      "دبلوم إنتاج وتصنيع",
      "دبلوم صيانة آلات",
      "دبلوم مختبرات",
      "دبلوم تمريض",
      "دبلوم سجلات طبية",
      "دبلوم صحة عامة",
      "دبلوم خدمة اجتماعية",
    ],
  },
];

export default majors;
